import { Button, Card, Col, Form, Input, Row, Table, Typography } from "antd";

import dayjs from "dayjs";
import React, { Fragment, useEffect, useState } from "react";
import { CSVLink } from "react-csv";
import { toast } from "react-toastify";
import ViewBtn from "../Buttons/ViewBtn";
import UserPrivateComponent from "../PrivateRoutes/UserPrivateComponent";
import ColVisibilityDropdown from "../Shared/ColVisibilityDropdown";
import { CsvLinkBtn } from "../UI/CsvLinkBtn";
import { addRole, getRoles } from "./roleApis";

function CustomTable({ list }) {
	const [columnsToShow, setColumnsToShow] = useState([]);

	const columns = [
		{
			id: 1,
			title: "S.No",
			dataIndex: "serial",
			key: "serial",
		},
		{
			id: 2,
			title: "Name",
			dataIndex: "name",
			key: "name",
		},

		{
			id: 3,
			title: "Created at",
			dataIndex: "createdAt",
			key: "addrcreatedAtess",
			render: (createdAt) => dayjs(createdAt).format("YYYY-MM-DD"),
		},
		{
			id: 4,
			title: "Action",
			dataIndex: "id",
			key: "action",
			render: (id) => (
				<>
					<UserPrivateComponent permission={"readSingle-role"}>
						<ViewBtn path={`/admin/role/${id}/`} />
					</UserPrivateComponent>
				</>
			),
		},
	];

	useEffect(() => {
		setColumnsToShow(columns);
	}, []);

	const columnsToShowHandler = (val) => {
		setColumnsToShow(val);
	};

	// const addKeys = (arr) => arr.map((i) => ({ ...i, key: i.id }));
	const addKeys = (arr) => arr.map((i, index) => ({ ...i, key: i.id, serial: index + 1 }));


	return (
		<Card>
			<div className='text-center my-2 flex justify-between'>
				<h5 className='text-xl role-list-title mb-2'>Role List</h5>
				{list && (
					<div>
						<CsvLinkBtn>
							<CSVLink
								data={list}
								className='btn btn-dark btn-sm mb-1'
								filename='roles'>
								Download CSV
							</CSVLink>
						</CsvLinkBtn>
					</div>
				)}
			</div>

			{list && (
				<div style={{ marginBottom: "30px" }}>
					<ColVisibilityDropdown
						options={columns}
						columns={columns}
						columnsToShowHandler={columnsToShowHandler}
					/>
				</div>
			)}

			<Table
				scroll={{ x: true }}
				loading={!list}
				columns={columnsToShow}
				dataSource={list ? addKeys(list) : []}
			/>
		</Card>
	);
}

const AddRole = ({ drawer }) => {
	const [list, setList] = useState(null);
	const [loader, setLoader] = useState(false);

	useEffect(() => {
		
		getRoles()
			.then((d) => setList(d))
			.catch((error) => console.log(error));
	}, []);

	// useEffect(() => {
    //     const companyId = getCompanyIdFromToken();
    //     getRoles(companyId)
    //         .then((roles) => {
    //             // Filter roles based on company_id
    //             const filteredRoles = roles.filter(role => role.company_id === companyId);
    //             setList(filteredRoles);
    //         })
    //         .catch((error) => console.log(error));
    // }, []);

	const { Title } = Typography;

	const onFinish = async (values) => {
		setLoader(true);
		const resp = await addRole(values);

		if (resp.message === "success") {
			setLoader(false);
			const newList = [...list];
			newList.push(resp.data);
			setList(newList);
		}
	};

	const onFinishFailed = (errorInfo) => {
		toast.warning("Failed at adding role");
		setLoader(false);
	};
	return (
		<UserPrivateComponent permission={"create-role"}>
			<Row className="mr-top" gutter={[16, 16]} justify="space-between" align="top">
				{/* Form Column */}
				<Col xs={24} sm={24} md={12} lg={8} xl={8} className="column-design border rounded card-custom" style={{ minHeight: "auto", padding: "20px" }}>
					<Title level={4} className="mt-10 m-2 text-center">Add New Role</Title>
					<Form
						name="basic"
						labelCol={{ span: 6 }}
						wrapperCol={{ span: 12 }}
						onFinish={onFinish}
						onFinishFailed={onFinishFailed}
						autoComplete="off"
					>
						<Form.Item
							label="Name"
							name="name"
							rules={[{ required: true, message: "Please input role name!" }]}
						>
							<Input />
						</Form.Item>
	
						<Form.Item wrapperCol={{ offset: 6, span: 12 }}>
							<Button
								onClick={() => setLoader(true)}
								type="primary"
								size="large"
								htmlType="submit"
								block
								loading={loader}
							>
								Add New Role
							</Button>
						</Form.Item>
					</Form>
				</Col>
	
				{/* Table Column */}
				<UserPrivateComponent permission={"readAll-role"}>
					<Col xs={24} sm={24} md={20} lg={16} xl={16}>
						{drawer || <CustomTable list={list} />}
					</Col>
				</UserPrivateComponent>
			</Row>
		</UserPrivateComponent>
	);
	
	
};

export default AddRole;
